export const CONTENT_CODE = {
    SYSTEM_DEFAULT: 'systemdefault'
};



// WEBPACK FOOTER //
// ./src/constants/ContentCode.js